import { getI18n } from 'client/AppReducer';
import {
  clearErrorMessage,
  loginError,
  loginUser,
  receiveLogin,
} from 'client/modules/Auth/AuthActions';
import { getErrorMessage, getNextPath } from 'client/modules/Auth/AuthReducer';
import withNavigate from 'client/util/withNavigate';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import LoginWidget from './LoginWidget';

function LoginWidgetContainer(props) {
  const googleSigninId = 'google-signin';

  return <LoginWidget googleSigninId={googleSigninId} {...props} />;
}

LoginWidgetContainer.defaultProps = {
  isSignup: false,
};

LoginWidgetContainer.propTypes = {
  onLoginClick: PropTypes.func.isRequired,
  lang: PropTypes.string.isRequired,
  isSignup: PropTypes.bool,
};

const mapStateToProps = state => {
  return {
    errorMessage: getErrorMessage(state),
    lang: getI18n(state).locale,
    nextPath: getNextPath(state),
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onLoginClick(creds, isSignup) {
    // Handle passkey authentication result
    if (creds.passkeyAuthenticated && creds.user) {
      dispatch(receiveLogin(creds.user));
      // For passkey auth, just navigate to home - the proper redirect logic will be handled by the auth flow
      ownProps.navigate('/', { replace: true });
      return;
    }

    // Regular login flow
    dispatch(loginUser(creds, isSignup, ownProps.navigate));
  },
  onLoginError(msg) {
    dispatch(loginError(msg));
  },
  onCloseError() {
    dispatch(clearErrorMessage());
  },
});

export default withNavigate(connect(mapStateToProps, mapDispatchToProps)(LoginWidgetContainer));
